
import React from 'react';
import { connect } from 'react-redux';
import { CALCULATE_ZONE_CLASSIFICATION } from '__editor/panelsEditor/components/settings/settingsActions';
import LoadingStatusModal from './LoadingStatusModal';

interface Props {
    calculateZoneClassication: boolean;
    dispatch: (action: any) => void;
}

class CalculateZoneClassificationModal extends React.Component<Props> {
  
  handleClose = () => {
    this.props.dispatch(CALCULATE_ZONE_CLASSIFICATION(false));
  };

  render() {
    if (!this.props.calculateZoneClassication) {
      return null;
    }

    return (
      <LoadingStatusModal
        id="zone-recalculation"
        visible={this.props.calculateZoneClassication}
        title="Zone classification calculation"
        message="Refreshing roof zone classification based on the latest project settings."
        hint="This may take a moment while we update the design data used by the rest of the workflow."
      />
    );
  }
}

const mapStateToProps = (appState: appState) => ({
    calculateZoneClassication: appState.settings.calculateZoneClassication,
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(CalculateZoneClassificationModal);

